(function () {

  const products_block__wrapper = document.querySelector('.js_products_block__wrapper')
  if (products_block__wrapper) {
    breakTitle(products_block__wrapper);
    handleEqualHeightOnContentElements(products_block__wrapper);

    window.addEventListener("resize", (event) => {
      handleEqualHeightOnContentElements(products_block__wrapper);
    });
  }


  function breakTitle(products_block__wrapper) {
    const productsItems = products_block__wrapper.querySelectorAll(".product-item--title a");

    productsItems.forEach(item => {
      const originalHtml = item.innerHTML.replace(/^\s+/, '');
      const firstWord = originalHtml.split(' ')[0];
      const remainingContent = originalHtml.slice(firstWord.length + 1);
      item.innerHTML = `${firstWord}</br>${remainingContent}`;
    });
  }

  function handleEqualHeightOnContentElements(products_block__wrapper) {
    const _contents = products_block__wrapper.querySelectorAll('.product-content');

    if (window.innerWidth > 767) {
      setEqualHeightOnContentElements(_contents);
    }
    else {
      _contents.forEach((content) => {
        content.children[0].style.height = 'initial';
        content.children[1].style.height = 'initial';
      });
    }
  }

  function setEqualHeightOnContentElements(contents) {

    if (contents) {

      let _titleMaxHeight = 0;
      let _textMaxHeight = 0;

      contents.forEach((content) => {
        _titleMaxHeight = getElementMaxHeight(content.children[0], _titleMaxHeight);
        _textMaxHeight = getElementMaxHeight(content.children[1], _textMaxHeight);
      });

      contents.forEach((content) => {
        content.children[0].style.height = _titleMaxHeight + 'px';
        content.children[1].style.height = _textMaxHeight + 'px';
      });

    }
  }

  function getElementMaxHeight(el, elMaxHeight) {
    if (el.clientHeight > elMaxHeight) {
      elMaxHeight = el.clientHeight;
    }

    return elMaxHeight;
  }

})()
